module.exports = __webpack_public_path__ + "static/media/lock.51f05f2f.svg";